export const CLIPP_360 = 25;
export const ORDEM_CLIPP_360 = 26;
export const MODULIZED_BASIC = 29;
export const MODULIZED_INTERMEDIARY = 30;
export const MODULIZED_ADVANCED = 31;
export const RESELLER = 7;
export const TRIAL = 6;
